import * as tslib_1 from "tslib";
import ThemeSwatch from './ThemeSwatch';
import { commitQuickThemeChange } from '../orchestration/commitThemeChange';
import toggleThemeQuickOptionExpansion from '../data/mutators/toggleThemeQuickOptionExpansion';
import getStore from '../data/store/store';
import { observer } from 'mobx-react';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { FocusZone } from 'office-ui-fabric-react/lib/FocusZone';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import { getSupportedThemeIds } from 'owa-theme';
import * as React from 'react';
var styles = require('./Theme.scss');
var COLLAPSED_SIZE = 5;
var ThemeQuick = /** @class */ (function (_super) {
    tslib_1.__extends(ThemeQuick, _super);
    function ThemeQuick(props) {
        var _this = _super.call(this, props) || this;
        // Pin the initially selected theme to the front of the list for as long as this control is mounted
        _this.pinnedTheme = getUserConfiguration().UserOptions.ThemeStorageId || 'base';
        return _this;
    }
    ThemeQuick.prototype.componentDidMount = function () {
        toggleThemeQuickOptionExpansion(false);
    };
    ThemeQuick.prototype.render = function () {
        var _this = this;
        var isExpanded = getStore().isQuickOptionExpanded;
        var themeIds = getSupportedThemeIds();
        // Push the initially saved theme to the front of the list
        var pinnedThemeIndex = themeIds.indexOf(this.pinnedTheme);
        if (pinnedThemeIndex) {
            // If the theme can't be found, don't pin an empty theme.
            themeIds.splice(pinnedThemeIndex, 1);
            themeIds.unshift(this.pinnedTheme);
        }
        if (!isExpanded) {
            themeIds = themeIds.slice(0, COLLAPSED_SIZE);
        }
        return (React.createElement("div", { className: styles.quickContainer },
            React.createElement(FocusZone, { className: styles.swatchContainer, role: "listbox" }, themeIds.map(function (id) { return (React.createElement(ThemeSwatch, { themeId: id, onClick: _this.onThemeClick, key: id })); })),
            React.createElement(CommandButton, { text: isExpanded ? strings.themeCollapseLabel : strings.themeExpandLabel, onClick: this.toggleExpand, className: styles.expandButton })));
    };
    ThemeQuick.prototype.toggleExpand = function () {
        toggleThemeQuickOptionExpansion();
    };
    ThemeQuick.prototype.onThemeClick = function (themeId) {
        commitQuickThemeChange(themeId);
    };
    ThemeQuick = tslib_1.__decorate([
        observer
    ], ThemeQuick);
    return ThemeQuick;
}(React.Component));
export default ThemeQuick;
//# sourceMappingURL=ThemeQuick.js.map